import cn from "classnames"

import { getLanguageIcon } from "@/icons"
import styles from "../Icon.module.scss"
import { PackageManagerProps } from "./PackageManager.types"

const packageManagerToLanguage: Record<PackageManager, Language> = {
  PACKAGE_MANAGER_GO_MODULES: "go",
  PACKAGE_MANAGER_NPM: "javascript",
  PACKAGE_MANAGER_PIP: "python",
  PACKAGE_MANAGER_POETRY: "python",
  PACKAGE_MANAGER_RUBYGEMS: "ruby",
  PACKAGE_MANAGER_MAVEN: "java",
  PACKAGE_MANAGER_COMPOSER: "php",
  PACKAGE_MANAGER_YARN: "javascript",
  PACKAGE_MANAGER_PNPM: "javascript",
  PACKAGE_MANAGER_SBT: "scala",
  PACKAGE_MANAGER_UNSPECIFIED: "unknown",
  PACKAGE_MANAGER_NUGET: "dotnet",
  PACKAGE_MANAGER_CARGO: "rust",
  PACKAGE_MANAGER_COCOAPODS: "swift",
  PACKAGE_MANAGER_BOWER: "javascript",
  PACKAGE_MANAGER_CONAN: "c",
  PACKAGE_MANAGER_HELM: "unknown",
  PACKAGE_MANAGER_GRADLE: "java",
  PACKAGE_MANAGER_UV: "python",
  // Unity packages report dotnet everywhere else in the stack (syft, pako,
  // runtime correlation), so the icon follows.
  PACKAGE_MANAGER_UPM: "dotnet",
  PACKAGE_MANAGER_BUN: "javascript",
  // OpenHarmony apps are written in ArkTS, a TypeScript dialect. The rest of the
  // stack reports the language as "arkts" so that vulnerability matching does not
  // route these packages at npm advisory data; that distinction has no bearing on
  // which glyph to show, so the icon falls back to TypeScript.
  PACKAGE_MANAGER_OHPM: "typescript"
}

const packageManagerIcon = (packageManger: PackageManager) => {
  const language = packageManagerToLanguage[packageManger]
  return getLanguageIcon(language)
}

export const PackageManagerIcon = ({
  className,
  packageManager = "PACKAGE_MANAGER_UNSPECIFIED",
  ...props
}: PackageManagerProps) => {
  const Icon = packageManagerIcon(packageManager)

  return (
    <Icon
      className={cn(styles.withBackground, className)}
      data-tooltip-content={packageManagerToLanguage[packageManager]}
      data-tooltip-translation="true"
      {...props}
    />
  )
}
